import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useNumbersLayerContext } from 'pages/settings/pages/numbers/context/numbersLayerContext'
import { TextEnableLandlineStepsProvider } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'

const TextEnableLandlineProviderLayoutContent = observer(() => {
  return (
    <>
      <Outlet />
    </>
  )
})

export const TextEnableLandlineProviderLayout = () => {
  const numbersLayerStore = useNumbersLayerContext()

  return (
    <TextEnableLandlineStepsProvider numbersLayerStore={numbersLayerStore}>
      <TextEnableLandlineProviderLayoutContent />
    </TextEnableLandlineStepsProvider>
  )
}
